import { useLayoutEffect, useState, useContext } from "react";
import Phaser from "phaser";
import { context } from "../PhaserProvider";

const usePhaser = () => {
  const { game, scene, sceneProps } = useContext(context);
  const getState = (game, scene) => {
    game.scene.scenes.forEach((s) => {
      s.events.off(Phaser.Scenes.Events.READY);
      s.events.once(Phaser.Scenes.Events.READY, () => {
        s.events.off(Phaser.Scenes.Events.RENDER);
        s.events.once(Phaser.Scenes.Events.RENDER, () => {
          setState({
            ...s,
            camera: s.cameras.main,
            cameras: s.cameras,
            scene: s,
          });
        });
      });
    });
    return {
      game,
      scene, // current scene based on last scene that called RPFScene.create
      sceneProps, // current scene data recieved into scene.create method
      camera: scene.cameras.main,
      cameras: scene.cameras,
      scenes: game.scene.scenes,
      scenesManager: game.scene,
    };
  };
  const [state, setState] = useState({});
  useLayoutEffect(() => {
     if (scene) {
       setState(getState(game, scene))
     }
  }, [game, scene])

  return state;
};
export default usePhaser;
